import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface SocialMediaShareOpts {
    url: string;
    text: string;
    title: string;
}

@Component({
    selector: "app-share-social-medias-dialog",
    templateUrl: "./share-social-medias-dialog.component.html",
    styleUrls: ["./share-social-medias-dialog.component.scss"]
})
export class ShareSocialMediasDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: SocialMediaShareOpts) {}

    shareOnLinkedIn(): void {
        const url = `https://www.linkedin.com/sharing/share-offsite/?url=${this.data.url}&text=${this.data.text}`;

        window.open(url, "_blank");
    }

    shareOnFacebook(): void {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${this.data.url}`;

        window.open(url, "_blank");
    }

    shareOnX(): void {
        const url = `https://twitter.com/intent/tweet?url=${this.data.url}&text=${this.data.text}`;

        window.open(url, "_blank");
    }

    shareOnBluesky(): void {
        const url = `https://bsky.app/intent/compose?text=${this.data.text} ${this.data.url}`;
        window.open(url, "_blank");
    }

    shareOnThreads(): void {
        const url = `https://threads.net/intent/post?text=${this.data.text} ${this.data.url}`;
        window.open(url, "_blank");
    }

    shareOnWpp(): void {
        const url = `https://wa.me/?text=${this.data.text} ${this.data.url}`;
        window.open(url, "_blank");
    }
}
